import { convertSnapshot } from '../../../global/cnr/contexts/contextHelpers';
import { createRefPath_event } from '../../../global/firestoreData/appData/appRefPaths';
import { _globalTicketingName, _useTicketingSubCollection } from '../cnr/reducers/TicketingReducer';

export const getTicketing = (database_fns, pathViews, callback, callbackAlt) => {

  const _refPath = createRefPath_event(pathViews, [_globalTicketingName])

  database_fns.get_data({ refPath: _refPath }).then(data => {
    callback(data)
    if (_useTicketingSubCollection) {
      if (data) {
        Object.keys(data).forEach(key => {
          const _ticketPaths = createRefPath_event(pathViews, [_globalTicketingName, key, 'userTickets'])
          database_fns.get_data({ refPath: _ticketPaths }).then(sss => {
            const dataC = convertSnapshot(sss, false, { ignoreId: true })
            callbackAlt(dataC, key)
          })
        })
      }
    } else {
      callback(data)
    }
  })
} 